import { render } from "./ProfilePrice.vue?vue&type=template&id=29227aa0&scoped=true"
import script from "./ProfilePrice.vue?vue&type=script&lang=js"
export * from "./ProfilePrice.vue?vue&type=script&lang=js"

import "./ProfilePrice.vue?vue&type=style&index=0&id=29227aa0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29227aa0"]])

export default __exports__